import React, { Component } from 'react'

import Title from '../common/title'
import AriaMessage from '../common/ariaMessage'
import Controls from '../common/controls'

class CoachingUnavailable extends Component {
  constructor(props) {
    super(props)
    
    this.next = this._next.bind(this)
  }

  _next() {
    this.props.next(this.props.match.path)
  }

  render() {
    return (
      <div id="coaching-unavailable">
        <AriaMessage message="Navigated to coaching unavailable page" />
        <Title>Schedule Your Coaching Sessions</Title>
        <div className="container">
          <h2>You're just a phone call away from starting your coaching!</h2>
          <p className="call-client">Please contact Client Care at 1-888-639-8181 to help you schedule your coaching sessions. 
            The best way to get started with the program is to schedule a few regular calls with your Newtopia Inspirator. 
            We're standing by and ready to help you get started.
          </p>
          <div className="to-profile-wrapper">
            <Controls nextLabel="CONTINUE TO PROFILE" next={this.next} />
          </div>
        </div>
      </div>
    )
  }
}

export default CoachingUnavailable